module.exports = __webpack_public_path__ + "img/V12.e3edbb89.png";